/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { css } from "@emotion/css";
import logo from "../../components/assests/images/CC-Logo.svg";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Grid, Menu, MenuItem, IconButton, Typography, Avatar } from "@mui/material";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import en from "../../nls/en.json";
import { useDispatch, useSelector } from "react-redux";
import LockClockOutlinedIcon from "@mui/icons-material/LockClockOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { ThemeProvider } from "@mui/material/styles";
import { getNotificationCount, getNotifications, getQuestionsSavedAnswers } from "../../store/studentSlice";
import { getStudentFlow } from "../../store/commonSlice";
import { setUserType } from "../../store/userSlice";
import { checkUsersMeetingFeedback } from "../../store/calendlySlice";
import ProfilePic from "../../components/assests/images/cap-green.svg";
import { isEmpty, role_name, user_type } from "../../utils/constants";
import Loader from "../../utils/Loader";
import Style from "../../components/Styles/CssModulesGlobal.module.scss";
import { theme, HeaderBox, UserWrapper, paperPropsCSSObj } from "./HeaderStyles";
import ChangePasswordModal from "../../components/Landing/ChangePasswordModal";
import CustomDialogPopUp from '../../components/common/PopUp/CustomDialogPopUp';
import NotificationPopUp from "../../components/common/PopUp/NotificationPopUp";
import Feedbackmeetings from "../../components/Meetings/FeedbackMeetings";

const getUserWrapper = (savedAnswer) => {
  return (
    <UserWrapper>
      <Typography
        sx={{
          width: 1,
          fontSize: "12px",
          color: "#333",
          lineHeight: "12px",
          textAlign: "right",
        }}
      >
        {savedAnswer?.BASIC_INFORMATION?.name?.split(" ")[0]}
      </Typography>
      <Typography
        sx={{
          width: 1,
          fontSize: "10px",
          color: "#666",
          textAlign: "right",
        }}
      >
        {savedAnswer?.BASIC_INFORMATION?.role_name === role_name.SUPER_ADMIN ? "Super Admin" : savedAnswer?.BASIC_INFORMATION?.role_name}
      </Typography>
    </UserWrapper>
  )
}

// eslint-disable-next-line max-lines-per-function
const Header = ({ isOnboarding = false }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { loader } = useSelector(({ common }) => common);
  const { userInfo, savedAnswer, notificationCount, notifications } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { pendingMeetingFeedback } = useSelector(({ calendly }) => calendly);
  const { BASIC_INFORMATION } = savedAnswer;

  const [ismeetingFeedbackPending, checkMeetingFeedback] = useState({count: 0});
  useEffect(() => {
    if (!isEmpty(pendingMeetingFeedback)) {
      checkMeetingFeedback(prevState => ({
        count: prevState.count + 1
      }));
    } else {
      checkMeetingFeedback({count: 0});
    }
  }, [pendingMeetingFeedback, location]);
  const isMeetingPage = location?.pathname === '/user/meetings';

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null);
  const handleNavigateToProfilePage = () => navigate("/profile");

  const signOut = () => {
    Auth.signOut().then(() => {
      localStorage.clear();
      navigate("/");
      window.location.reload();
    });
  };

  useEffect(() => {
    if (BASIC_INFORMATION?.user_type === 'b2c_student') {
      dispatch(getStudentFlow());
    }
  }, [BASIC_INFORMATION?.user_type]);

  useEffect(() => {
    dispatch(getNotificationCount());
    dispatch(getNotifications());
    dispatch(getQuestionsSavedAnswers());
    dispatch(checkUsersMeetingFeedback());
    let isB2B = null;
    if (savedAnswer?.BASIC_INFORMATION?.role_name === role_name.STUDENT) {
      isB2B = savedAnswer?.BASIC_INFORMATION?.user_type === user_type.B2B;
      if (isB2B) {
        dispatch(setUserType(user_type.B2B));
      } else {
        dispatch(setUserType(user_type.B2C));
      }
    }
  }, []);

  // changes pwd functionality 
  const [showModal, setShowModal] = useState(false);
  const handlePasswordChange = () => {
    setShowModal(true);
  }
  const handleChangePasswordClose = () => {
    setShowModal(false);
  }

  //To close the dropdown menu once selected anything from menu.
  useEffect(() => {
    if (!showModal) {
      setAnchorEl(null)
    }
  }, [showModal]);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // State to control the success popup
  const [notificationPopup, setNoficationPopup] = useState(false);
  //Success conditional Popup's after submiting change password
  const passWordUpdated = (data) => {
    if (data?.messageKey === 'SUCCESS') {
      setShowSuccessPopup(true);
    }
  }

  const isMentor = BASIC_INFORMATION?.role_name === role_name.MENTOR;
  const isSuperAdmin = BASIC_INFORMATION?.role_name === role_name.SUPER_ADMIN;
  const isCollegeAdmin = BASIC_INFORMATION?.user_type === user_type.COLLEGE_ADMIN;
  const isStudent = BASIC_INFORMATION?.role_name === role_name.STUDENT;

  return (
    <ThemeProvider theme={theme}>
      {loader && <Loader loader={true}></Loader>}
      <HeaderBox>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={6}><img src={logo} alt="College Contact" /></Grid>
          <Grid
            item
            xs={6}
            className={css`
              display: inline-flex;
              justify-content: flex-end;
              align-items: center;
            `}
          >
            {/* {BASIC_INFORMATION?.is_survey_completed === 1 && */}
            <IconButton aria-label="Notifications" className="bell">
              <NotificationPopUp
                setNoficationPopup={setNoficationPopup}
                notificationPopup={notificationPopup}
                notifications={notifications}
                notificationCount={notificationCount}
              />
            </IconButton>
            {/* } */}
            {getUserWrapper(savedAnswer)}

            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              {isMentor ? (
                <Avatar
                  alt={`${savedAnswer?.BASIC_INFORMATION?.name?.split(" ")[0]}'s Profile picture`}
                  src={BASIC_INFORMATION.profile_page_link}
                  sx={{ width: 35, height: 35 }}
                />
              ) : (
                <Avatar
                  alt={`${savedAnswer?.BASIC_INFORMATION?.name?.split(" ")[0]}'s Profile picture`}
                  src={isEmpty(BASIC_INFORMATION?.profile_page_link) ? (!isSuperAdmin && !isCollegeAdmin && ProfilePic) : BASIC_INFORMATION?.profile_page_link}
                  sx={{ width: 35, height: 35 }}
                  className={Style.imgWrapperHeader}
                />
              )}

            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={paperPropsCSSObj}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem
                disabled={isSuperAdmin || isOnboarding}
                onClick={() => handleNavigateToProfilePage()}>
                <AccountCircleOutlinedIcon
                  sx={{
                    color: "#1468A2",
                    marginRight: "8px",
                    fontSize: "20px",
                  }}
                />{" "}
                {en.PROFILE}
              </MenuItem>
              <MenuItem onClick={handlePasswordChange}>
                <LockClockOutlinedIcon
                  sx={{
                    color: "#1468A2",
                    marginRight: "8px",
                    fontSize: "20px",
                  }}
                />{" "}
                {en.CHANGE_PASSWORD}
              </MenuItem>
              {showModal && <ChangePasswordModal showModal={showModal} handleClose={handleChangePasswordClose} passWordUpdated={passWordUpdated} />}
              <MenuItem
                onClick={() => { signOut(); }}
              >
                <LogoutOutlinedIcon
                  sx={{
                    color: "#1468A2",
                    marginRight: "8px",
                    fontSize: "20px",
                  }}
                />{" "}
                {en.SIGN_OUT}
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>

        {/* Custom success popup */}
        <CustomDialogPopUp
          size="xs"
          openPopup={showSuccessPopup}
          togglePopUp={() => setShowSuccessPopup(false)}
          handleSubmit={() => setShowSuccessPopup(false)}
          allStrings={{
            TITLE: 'Success',
            BODY: en.PWD_CHANGE_SUCCESS,
            SUBMIT: 'OK',
          }}
        />

        {/* Meetings feedback popup */}
        {/* <CustomDialogPopUp
          size="xs"
          showCloseBtn={false}
          PopUpIcon={"clockIcon"}
          openPopup={ismeetingFeedbackPending}
          togglePopUp={() => checkMeetingFeedback(false)}
          handleSubmit={() => isMeetingPage ? checkMeetingFeedback(false) : navigate('/user/meetings', { state: { openFeedbackTab: true } })}
          allStrings={{
            TITLE: 'Meeting Feedback is pending',
            SUBMIT: isMeetingPage ? 'Close' : 'Go to Meeting page',
          }}
        /> */}
        {ismeetingFeedbackPending?.count > 0 && <Feedbackmeetings meetingData={pendingMeetingFeedback[0]} defaultOpen={ismeetingFeedbackPending?.count}></Feedbackmeetings>}
      </HeaderBox>
    </ThemeProvider>
  );
};

Header.propTypes = {
  isOnboarding: PropTypes.bool,
};

export default Header;
